// extracted by mini-css-extract-plugin
export default {"main_wrapper":"loaderScreen_main_wrapper__7y6uL"};